import { Action, createActionGroup, createFeature, createFeatureSelector, createReducer, on } from '@ngrx/store'
import { Informable, InformableType, InformableState, informableStateCreator, makeDefaultEventInfo, makeDefaultExhibitorInfo, makeDefaultExhibitorsInfo, makeDefaultPerformerInfo, makeDefaultPerformersInfo, makeDefaultResourcesInfo, makeDefaultResourceInfo, makeDefaultAttendeeInfo, makeDefaultAttendeesInfo } from 'globals/store/informables.data';
import { userActions } from './user.era';
import { eventsActions } from './events.era';

export { InformableState }


export const informableActions = createActionGroup({
  source: 'Informable',
  events: {
    'Load Informable': (informable: Informable) => ({ informable }),
    'Add Default Entity Info': (entityType: InformableType, eventId:string, id:string) => ({ entityType, eventId, id }),
    'Load Defaults': (eventId:string) => ({ eventId }),
    'Remove Informable': (informableType: InformableType, key:string) => ({ informableType, key })
  }
})
export const informableReducer = createReducer(
  informableStateCreator(),
  on(informableActions.loadInformable, (state, { informable }) => {
    const { type, performerId, exhibitorId, resourceId } = informable
    let entityId
    switch(type) {
      case 'performer':
        entityId = performerId
        break;
      case 'exhibitor':
        entityId = exhibitorId
        break;
      case 'resource':
        entityId = resourceId
        break;
      default:
        return {...state, [type]: informable }
    }
    return {...state, [type]:{...state[type], [entityId]: informable }}
  }),
  on(informableActions.addDefaultEntityInfo, (state, { entityType, eventId, id }) => {
    if (state[entityType][id]) {
      console.log('ADD_DEFAULT_EVENT_ENTITY_INFO firing when it does not need to')
      return state;
    }
    let defaultInformable: Informable
    switch(entityType) {
      case 'attendee':
        defaultInformable = makeDefaultAttendeeInfo(eventId, id)
        break;
      case 'performer':
        defaultInformable = makeDefaultPerformerInfo(eventId, id)
        break;
      case 'exhibitor':
        defaultInformable = makeDefaultExhibitorInfo(eventId, id)
        break;
      case 'resource':
        defaultInformable = makeDefaultResourceInfo(eventId, id)
        break;
      default:
        console.log("Missing entityType for add default event entity", entityType)
        return state
    }
    return {...state, [entityType]: { ...state[entityType], [id]: defaultInformable } }
  }),
  on(informableActions.loadDefaults, (state, { eventId }) => ({
    ...state,
    performers: state.performers ? state.performers : makeDefaultPerformersInfo(eventId),
    event: state.event ? state.event : makeDefaultEventInfo(eventId),
    exhibitors: state.exhibitors ? state.exhibitors : makeDefaultExhibitorsInfo(eventId),
    resources: state.resources ? state.resources : makeDefaultResourcesInfo(eventId),
    attendees: state.attendees ? state.attendees : makeDefaultAttendeesInfo(eventId)
  })),
  on(informableActions.removeInformable, (state, { informableType, key }) => {
    console.log("REMOVE INFORMABLE CALLED")
    const typeObject = {...state[informableType]}
    delete typeObject[key]
    return {
      ...state,
      [informableType]: typeObject
    }
  }),
  on(userActions.logout, (state) => informableStateCreator()),
  on(eventsActions.unloadEvent, (state) => informableStateCreator())
)

export const informableFeature = createFeature({
  name: 'informables',
  reducer: informableReducer
})

export const informableStateSelector = createFeatureSelector<InformableState>(informableFeature.name)